import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

/**
 * User bailed out of Stripe Checkout (hit back or closed the tab).
 * Nothing was charged — just show a friendly "no worries" screen and route
 * them either back to /upgrade or /discover.
 */
export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="mx-auto max-w-md px-6 pt-12 pb-24 text-center" data-testid="payment-cancel-page">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-neutral-800/80">
        <XCircle size={32} className="text-neutral-400" />
      </div>
      <h1 className="mt-6 font-display text-2xl text-white">Payment cancelled</h1>
      <p className="mt-2 text-sm text-neutral-400">
        Nothing was charged. Your account is unchanged. Change your mind and you can try again anytime.
      </p>
      <div className="mt-8 flex gap-3 justify-center">
        <button
          data-testid="payment-cancel-retry-btn"
          onClick={() => nav("/upgrade", { replace: true })}
          className="btn-pill btn-primary px-6"
        >
          Try again
        </button>
        <button
          data-testid="payment-cancel-home-btn"
          onClick={() => nav("/discover", { replace: true })}
          className="btn-pill btn-ghost px-6"
        >
          Back to app
        </button>
      </div>
    </div>
  );
}
